import React, { useState } from 'react';
import s from './Steps.module.css';
import { useSelector } from 'react-redux';
import { selectEmailVerification } from '../../../../store/selectors/authSelectors';
import { useAppDispatch } from '../../../../store/store';
import { sendVerificationCode, verifyEmailCode } from '../../../../store/slices/emailVerifySlice';
import { fetchCurrentUser } from '../../../../shared/api/authApi';

import Button from '../../../../shared/ui/button/Button';
import IconFullLeftArrow from '../../../../shared/ui/icons/IconFullLeftArrow';
import { useLocation, useNavigate } from 'react-router-dom';
interface RegistrationStep2Props {
    setStep: (step: number) => void;
    code: string;
    setCode: (code: string) => void;
    email: string | null;
}

const RegistrationStep2: React.FC<RegistrationStep2Props> = ({ email, setStep, code, setCode }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [codeArray, setCodeArray] = useState(
        code.length === 6 ? code.split('') : Array(6).fill(''),
    );
    const dispatch = useAppDispatch();

    const { isLoading, error, success, fieldErrors, resendLoading, resendSuccess, resendError } =
        useSelector(selectEmailVerification);

    const handleChange = (index: number, value: string) => {
        if (!/^[0-9]?$/.test(value)) return;

        const newCodeArray = [...codeArray];
        newCodeArray[index] = value;
        setCodeArray(newCodeArray);
        setCode(newCodeArray.join(''));

        const nextInput = document.getElementById(`code-input-${index + 1}`);
        if (value && nextInput) {
            (nextInput as HTMLInputElement).focus();
        }
    };

    const handleVerifyCode = async () => {
        if (email && code.length === 6 && !success) {
            const searchParams = new URLSearchParams(location.search);
            const type = searchParams.get('type');

            const action = await dispatch(verifyEmailCode({ email: email, code }));
            console.log(action);
            console.log(type);
            console.log(email);
            console.log(code);
            console.log(success);
            console.log(isLoading);
            console.log(error);
            console.log(fieldErrors);
            if (verifyEmailCode.fulfilled.match(action)) {
                if (type === 'login') {
                    await dispatch(fetchCurrentUser());
                    navigate('/dashboard');
                } else {
                    navigate('/onboarding');
                }
            } else {
                clearCode();
            }
        }

        if (success) {
            setStep(3);
        }
    };

    const onResendCode = async () => {
        if (email) {
            await dispatch(sendVerificationCode({ email: email }));
            clearCode();
        }
    };

    const clearCode = () => {
        setCodeArray(Array(6).fill(''));
        setCode('');
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('Text').replace(/\D/g, '');
        if (!pasteData) return;

        const digits = pasteData.split('').slice(0, 6);
        const newCodeArray = Array(6).fill('');
        digits.forEach((digit, idx) => {
            newCodeArray[idx] = digit;
        });

        setCodeArray(newCodeArray);
        setCode(newCodeArray.join(''));

        const nextIndex = digits.length < 6 ? digits.length : 5;
        const nextInput = document.getElementById(`code-input-${nextIndex}`);
        if (nextInput) {
            (nextInput as HTMLInputElement).focus();
        }
    };

    return (
        <form
            className={s.form}
            onSubmit={(e) => {
                e.preventDefault();
            }}
        >
            <p className={s.subtitle}>Enter the 6-digit code sent to your email</p>
            <div
                style={{
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'center',
                    margin: '20px 0',
                }}
            >
                {codeArray.map((digit, index) => (
                    <input
                        key={index}
                        id={`code-input-${index}`}
                        readOnly={success}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onPaste={(e) => handlePaste(e)}
                        className={s.codeInput}
                        style={{
                            width: '40px',
                            height: '40px',
                            color: success ? '#aaa' : '#333',
                            textAlign: 'center',
                            fontSize: '20px',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                        }}
                    />
                ))}
            </div>

            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <a
                    href={'https://mail.google.com'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.link}
                >
                    Go to my email
                </a>
            </div>

            {error && (
                <p style={{ color: 'red', textAlign: 'left', marginBottom: '10px' }}>{error}</p>
            )}

            {fieldErrors?.code && (
                <p style={{ color: 'red', textAlign: 'left', marginBottom: '10px' }}>
                    {fieldErrors.code}
                </p>
            )}
            <div className={s.resend_code_container}>
                <p className={s.text}>Didn’t receive the code? </p>
                <button
                    type="button"
                    onClick={onResendCode}
                    disabled={resendLoading || isLoading || success}
                    className={s.link}
                    style={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                    }}
                >
                    {resendLoading ? 'Resending...' : 'Resend code'}
                </button>

                {resendSuccess && (
                    <p
                        style={{
                            marginLeft: '5px',
                            color: 'green',
                            fontSize: '13px',
                            marginTop: '4px',
                        }}
                    >
                        {resendSuccess}
                    </p>
                )}

                {resendError && (
                    <p
                        style={{
                            marginLeft: '5px',
                            color: 'red',
                            fontSize: '13px',
                            marginTop: '4px',
                        }}
                    >
                        {resendError}
                    </p>
                )}
            </div>

            <Button
                text={isLoading ? 'Verifying...' : 'Continue'}
                onClick={handleVerifyCode}
                state={codeArray.join('').length === 6 && !isLoading ? 'enabled' : 'disabled'}
                icon={<IconFullLeftArrow />}
                iconPosition="right"
                style={{
                    background: '#FFDD35',
                    borderRadius: '26px',
                    fontWeight: '600',
                    height: '40px',
                    marginBottom: '20px',
                }}
            />
        </form>
    );
};

export default RegistrationStep2;
